import { ICauHinhLoaiDichVuItemRequest } from '../../models/request/dich-vu/cauHinhLoaiDichVuRequests';
import { IDichVuSelectRequest } from '../../models/request/dich-vu/dichVuRequests';
import { apiClient } from '../apiClient';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_CAUHINH_LOAIDICHVU_PATH = "cauhinh-loaidichvu";

class CauHinhLoaiDichVuApi extends BaseCRUDApi<ICauHinhLoaiDichVuItemRequest> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
	Select(request: IDichVuSelectRequest) {
		return apiClient.post(`${API_CAUHINH_LOAIDICHVU_PATH}/select`, request);
	}
}
export const cauHinhLoaiDichVuApi = new CauHinhLoaiDichVuApi(API_CAUHINH_LOAIDICHVU_PATH);
